import { Box, Typography, Button, Paper, useTheme } from '@mui/material';
import { CheckCircle, AccountBalance } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const StripeOnboardingReturn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const { storeId: authStoreId } = useAuth();

  const params = new URLSearchParams(location.search);
  const storeId = params.get('storeId') || authStoreId;

  const isRefresh = location.pathname.includes('/refresh');

  useEffect(() => {
    if (!isRefresh) {
      // Auto-redirect to payments page after a short delay
      const timer = setTimeout(() => {
        if (storeId) {
          navigate(`/store/${storeId}/payments`);
        } else {
          navigate('/stores');
        }
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [storeId, navigate, isRefresh]);

  const handleGoToPayments = () => {
    if (storeId) {
      navigate(`/store/${storeId}/payments`);
    } else {
      navigate('/stores');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        p: 3,
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
      >
        <Paper
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: 3,
            boxShadow: theme.shadows[4],
            maxWidth: 480,
            textAlign: 'center',
          }}
        >
          {isRefresh ? (
            <>
              <AccountBalance
                sx={{ fontSize: 64, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
                Session Expired
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                Your Stripe onboarding session has expired. Please start again from the Payments page.
              </Typography>
            </>
          ) : (
            <>
              <CheckCircle
                sx={{ fontSize: 64, color: theme.palette.success.main, mb: 2 }}
              />
              <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
                Onboarding Submitted
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                Thanks for submitting your details. Stripe will verify your information — this
                usually takes a few minutes. You'll be redirected to your payment settings shortly.
              </Typography>
            </>
          )}

          <Button
            variant="contained"
            size="large"
            onClick={handleGoToPayments}
            sx={{
              borderRadius: 1.5,
              textTransform: 'none',
              fontWeight: 600,
              px: 4,
            }}
          >
            Go to Payment Settings
          </Button>
        </Paper>
      </motion.div>
    </Box>
  );
};

export default StripeOnboardingReturn;
